<template>
  <div
    class="offer-card text-left"
    :class="offer.isArchived ? 'expired-offer' : ''"
  >
    <div class="card-wrapper row flex-wrap">
      <div class="col-12 col-md-2 column">
        <h1
          class="title"
          style="font-size: 0.9rem !important;"
          @click.stop="$router.push({ path: '/jobs/offer/' + offer.id + '/' + generateSlug })"
        >
          {{ shortOfferTitle }}
        </h1>
        <h1 class="company">
          <span v-if="offer && offer.user && offer.user.company && offer.user.company.title">
            {{ offer.user.company.title }}
          </span>
        </h1>
      </div>

      <div class="col-12 col-md-4 column">
        <div
          v-if="offer.isArchived"
          style="font-size: 0.8rem; color: #b74d4d;line-height: 0.5rem;"
        >
          {{ $t('generic.archived', 'Archived') }}
        </div>
        <div
          v-else-if="!offer.isPaid"
          style="font-size: 0.8rem; color: #b74d4d;line-height: 0.5rem;"
        >
          {{ $t('generic.unpaid', 'Unpaid') }}
        </div>
        <div
          v-else
          style="font-size: 0.8rem; color: green;line-height: 0.5rem;"
        >
          {{ $t('generic.active', 'Active') }}
        </div>
        <div>
          <span class="sm-text">
            {{ shortDate }}
          </span>
        </div>
        <h1 class="municipality">
          {{ offer.locationProvince }}, {{ offer.locationMunicipality }} ( {{ offer.locationCountry }} )
        </h1>
      </div>

      <div
        class="col-12 col-md-4 column"
        style="padding: 0 45px;"
      >
        <div
          class="row"
          @click="$router.push({ name: 'offer-candidates', query: { offer: offer.id } })"
        >
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-new' + offer.id">
                {{ $t('cards.offer-employer.candidate.new', 'New') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-new' + offer.id"
                class="mr-2 icon"
                icon="eye-slash"
              />
            </div>
            <div class="row">
              {{ offersCount('New') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-seen' + offer.id">
                {{ $t('cards.offer-employer.candidate.seen', 'Seen') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-seen' + offer.id"
                class="mr-2 icon"
                icon="hourglass"
              />
            </div>
            <div class="row">
              {{ offersCount('Seen') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-inprocess' + offer.id">
                {{ $t('cards.offer-employer.candidate.inprocess', 'In process') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-inprocess' + offer.id"
                class="mr-2 icon"
                icon="tasks"
              />
            </div>
            <div class="row">
              {{ offersCount('In process') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-accepted' + offer.id">
                {{ $t('cards.offer-employer.candidate.accepted', 'Accepted') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-accepted' + offer.id"
                class="mr-2 icon"
                icon="user-check"
              />
            </div>
            <div class="row">
              {{ offersCount('Accepted') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-rejected' + offer.id">
                {{ $t('cards.offer-employer.candidate.rejected', 'Rejected') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-rejected' + offer.id"
                class="mr-2 icon"
                icon="user-times"
              />
            </div>
            <div class="row">
              {{ offersCount('Rejected') }}
            </div>
          </div>
          <div class="col">
            <div class="row">
              <b-tooltip :target="'status-icon-invalid' + offer.id">
                {{ $t('cards.offer-employer.candidate.invalid', 'Not valid') }}
              </b-tooltip>
              <font-awesome-icon
                :id="'status-icon-invalid' + offer.id"
                class="mr-1 icon"
                icon="user-slash"
              />
            </div>
            <div
              class="row"
              style="margin-left: -10px;"
            >
              {{ offersCount('Invalid') }}
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-2 column">
        <div
          class="sm-text"
        >
          <b-dropdown
            id="dropdown-1"
            :text="$t('generic.actions', 'Actions')"
            size="sm"
            class="m-md-2"
          >
            <b-dropdown-item
              class="p-0"
              @click.stop="$router.push({ path: '/jobs/offer/' + offer.id + '/' + generateSlug })"
            >
              {{ $t('cards.one-offer.actions.view', 'View offer') }}
            </b-dropdown-item>

            <b-dropdown-item
              v-if="$hasRole(['admin']) && !offer.isArchived"
              class="p-0"
              @click.stop="$router.push({ name: 'edit-offer', params: { id: offer.id } })"
            >
              {{ $t('cards.one-offer.actions.edit', 'Edit offer') }}
            </b-dropdown-item>

            <b-dropdown-item
              class="p-0"
              @click.stop="$router.push({ name: 'offer-candidates', query: { offer: offer.id } })"
            >
              {{ $t('cards.one-offer.actions.view-candidates', 'View candidates') }}
            </b-dropdown-item>

            <b-dropdown-item
              v-if="!isDelegateRoute && (!offer.isArchived && offer.isPaid)"
              class="p-0"
              @click.stop="$router.push({ path: '/jobs/hr/delegate/' + offer.id + '?type=withcv&activeOnly=true' })"
            >
              {{ $t('cards.one-offer.actions.delegate-user', 'Delegate user') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="!isDelegateRoute && (!offer.isArchived && offer.isPaid)"
              class="p-0"
              @click.stop="$router.push({ path: '/jobs/hr/delegate-external/' + offer.id })"
            >
              {{ $t('cards.one-offer.actions.delegate-external-user', 'Delegate external candidate') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="isDelegateRoute && (!offer.isArchived && offer.isPaid)"
              class="p-0"
              @click="$emit('delegateModalToggle', offer.id)"
            >
              {{ $t('cards.one-offer.actions.delegate-offer', 'Delegate this offer') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="(!offer.isArchived && offer.isPaid)"
              class="p-0"
              @click="$emit('archiveModalToggle', offer.id)"
            >
              {{ $t('cards.one-offer.actions.archive', 'Archive') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="(offer.isArchived || !offer.isPaid)"
              class="p-0"
              @click="$emit('destroyModalToggle', offer.id)"
            >
              {{ $t('cards.one-offer.actions.delete', 'Delete') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      offer: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
      };
    },

    computed: {
      isDelegateRoute() {
        let routeChunks = this.$route.path.split("/");
        let route = routeChunks[1]
          + '/' + routeChunks[2]
          + '/' + routeChunks[3];

        return route === 'jobs/hr/delegate';
      },

      generateSlug() {
        return `${this.offer.titleTitle.replace(/[^A-Z0-9]+/ig, "-").toLowerCase()}` +
               `/${this.offer.locationProvince.replace(/[^A-Z0-9]+/ig, "-").toLowerCase()}`;
      },

      shortDate() {
        return this.offer.created_at.substring(0, 10);
      },

      shortOfferTitle() {
        let title = this.offer.titleTitle.substring(0, 25);
        if (this.offer.titleTitle.length > 25) {
          title += "...";
        }
        return title;
      }
    },

    methods: {
      offersCount(type) {
        if (Array.isArray(this.offer.offer_applies) && type) {
          return this.offer.offer_applies.filter((item) => item.status === type).length;
        }

        return 0;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .offer-card {
    background: white;
    padding: 15px 25px;
    margin-bottom: 0.5rem;
    transition: 0.2s ease;

    &:hover {
      box-shadow: 3px 3px 20px 0 rgba(210,210,210,1);
    }
  }

  h1.title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
    cursor: pointer;
  }

  h1.company {
    color: #009090;
    font-size: 0.7rem !important;
    text-transform: uppercase;
  }

  h1.municipality {
    color: #777;
    font-size: 0.8rem !important;
  }

  .sm-text {
    font-size: 0.9rem;
    color: #666;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .expired-offer {
    background: #f1ebeb;
    border: 1px solid white;
  }

  .column {
    margin: auto;
  }

  .card-wrapper {
    flex-direction: row;

    @media screen and (max-width: 767px) {
      & {
        flex-direction: column;
      }

      .column {
        text-align: left;
      }
    }
  }

  .icon {
    cursor: pointer;
  }

  .card {
    background: red;
  }
</style>
